import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import usePixel from 'app/hooks/usePixel';
import Analytics from 'app/lib/Analytics/Analytics';
import { useMediaResource } from 'app/lib/MediaHooks';

import * as lastPageActions from 'app/store/nodes/lastPage/actions';
import { IPageEnd as IPageEndData, IPagePromo as IPagePromoData } from 'app/store/nodes/card/interfaces';
import Promo from './Promo';

interface IPagePromo {
  data: IPageEndData | IPagePromoData,
}

const PagePromo: React.FC<IPagePromo> = memo((props) => {
  const { data } = props;
  const dispatch = useDispatch();

  const pixel = usePixel();

  const handleSkipPromo = useCallback(() => {
    Analytics.track().skipPromo();
    dispatch(lastPageActions.shiftStep());
  }, [dispatch]);

  const { containerRef: bannerContainerRef } = useMediaResource(data.items?.promo?.image);

  useEffect(() => {
    pixel.enable(data?.items?.promo?.pixel?.url);
  }, [data?.items?.promo?.pixel?.url]);

  if (!data) {
    return null;
  }

  const title = data.items?.promo?.title || '';
  const color = data.items?.promo?.button?.color || '';
  const url = data.items?.promo?.button?.url || '';
  const text = data.items?.promo?.button?.text || 'Click here';
  const isNextExists = data.items?.promo?.action === 'next';

  return (
    <Promo
      handleSkipPromo={isNextExists ? handleSkipPromo : undefined}
      bannerContainerRef={bannerContainerRef}
      title={title}
      color={color}
      url={url}
      text={text}
      hasButton={data?.items?.promo?.hasButton || false}
    />
  );
});

export default PagePromo;
